import { Stack } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2"
import { ReactElement } from "react"

import AppSkeleton from "./appSkeleton"
import { GRID_SPACING } from "../../../themes/defaultThemeParams"
import { COLUMNS_DNO_SINGLE } from "../../../webpages/dnoPortal/dnoSingleApplication"

const SingleApplicationSkeleton = (): ReactElement => (
    <Grid
        container
        display="flex"
        alignContent="flex-start"
        spacing={GRID_SPACING}
        columns={COLUMNS_DNO_SINGLE}
    >
        <Grid xs={COLUMNS_DNO_SINGLE}>
            <AppSkeleton height={80} aria-label="SingleApplicationSkeleton" />
        </Grid>
        <Grid xl={3} lg={4} xs={COLUMNS_DNO_SINGLE}>
            <Grid container spacing={GRID_SPACING} columns={COLUMNS_DNO_SINGLE}>
                <Grid xs={COLUMNS_DNO_SINGLE} sm={7} lg={COLUMNS_DNO_SINGLE}>
                    <AppSkeleton sx={{ minHeight: 375 }} height="100%" />
                </Grid>
                <Grid xs={COLUMNS_DNO_SINGLE} sm={8} lg={COLUMNS_DNO_SINGLE}>
                    <Stack spacing={GRID_SPACING}>
                        <AppSkeleton height={100} />
                        <AppSkeleton height={100} />
                        <AppSkeleton height={100} />
                    </Stack>
                </Grid>
                <Grid xs={COLUMNS_DNO_SINGLE} xl={COLUMNS_DNO_SINGLE}>
                    <AppSkeleton height={100} />
                </Grid>
            </Grid>
        </Grid>
        <Grid
            container
            display="flex"
            alignContent="flex-start"
            xl={12}
            lg={11}
            xs={COLUMNS_DNO_SINGLE}
        >
            <Grid xl={COLUMNS_DNO_SINGLE} xs={COLUMNS_DNO_SINGLE}>
                <AppSkeleton height={175} />
            </Grid>
            <Grid
                container
                display="flex"
                alignContent="flex-start"
                xl={7.5}
                xs={COLUMNS_DNO_SINGLE}
            >
                <Grid lg={COLUMNS_DNO_SINGLE} xs={COLUMNS_DNO_SINGLE}>
                    <AppSkeleton height={600} />
                </Grid>
                <Grid lg={COLUMNS_DNO_SINGLE} xs={COLUMNS_DNO_SINGLE}>
                    <AppSkeleton height={600} />
                </Grid>
            </Grid>
            <Grid xl={7.5} xs={COLUMNS_DNO_SINGLE}>
                <AppSkeleton height={1200} />
            </Grid>
        </Grid>
    </Grid>
)

export default SingleApplicationSkeleton
